(function () {
	"use strict";

	angular.module("swurveys.maker")
	.factory("embedSwurveyModal", embedSwurvey)
	.filter('trustAsResourceUrl', ['$sce', function($sce) {
		//This is so we can set iframe URL from angular
    return function(val) {
        return $sce.trustAsResourceUrl(val);
    };
}]);




	function embedSwurvey(ModalService, utilsService, analyticsService) {

		return {
			show :  function(swurveyId, userToken) {
				return ModalService.showModal({
					templateUrl: "app/modals/embeddedSwurvey/embeddedSwurvey.html",
					controller: ["$element", "close", function ($element, close) {
						var modal = this;
						this.close = function (confirm) {
							close(confirm, 500);
							$(".modal-backdrop")
								.remove();
						};
						this.skip = function() {
							analyticsService.trackEvent('SkipEmbeddedSwurvey', swurveyId);
							modal.close(true);
						}


						modal.embeddedLink = "https://app.swurveys.com/#/s/"+swurveyId +"?userToken=" + userToken;

						var listener = function(e){
							//Wait for the preload before showing the modal
							if(e.data && e.data.event == "SwurveyStarted" && e.data.swurveyId == swurveyId)
							{
								//Disable the SWOT
								e.source.postMessage({ event: "DisableSWOT", swurveyId: swurveyId}, "*");
						    analyticsService.trackEvent('StartEmbeddedSwurvey', swurveyId);
								//It has loaded, let's show it
			  	      $element.modal();
							}
							if(e.data && e.data.event == "SwurveyPostResponseStart" && e.data.swurveyId == swurveyId)
							{
								$element.modal('hide');
								modal.close(true);
								analyticsService.trackEvent('CompleteEmbeddedSwurvey', swurveyId);
								//remove self from listeners. Don't need to mess with future embeds in the same session
								this.removeEventListener('message', listener);
							}
						};
						window.addEventListener("message", listener);
					}],
					controllerAs: "modal"
				});
			}
		}

	}

}());
